<template>
    <div class="col-12 col-sm-3 study-list-item">
        <div class="study-product-logo">
            <img :src="studyProduct.logo">
            <div class="study-product-name">
                {{ studyProduct.name }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StudyListItem",
        props: {
            studyProduct: {
                type: Object,
            },
        },
    }
</script>

<style>
    .study-list-item {
        cursor: pointer;
    }
    .study-product-logo img {
        border-radius: 50%;
        max-width: 100%;
        /*width: 254px;*/
        object-fit: cover;
        max-height: 254px;
        outline: 3px solid #ffffff8c;
        outline-offset: -10px;
    }
    .study-product-logo {
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .study-product-name {
        min-height: 37px;
        max-width: 254px;
        margin: 0 auto;
        background: #00b4f1;
        border-radius: 37px;
        font-family: Manrope Bold Alt;
        color: #fff;
        font-size: 22px;
        line-height: 34px;
        margin-top: -30px;
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
    }
    .study-product-name:hover {
        background: #239bc3;

    }
</style>
